import React, {useEffect, useState} from 'react';
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "../../shadCn/components/ui/select";

function TableSizeSelect({Listener, setPageable}) {
    const [callFlag, setCallFlag]= useState(false);

    const handleValueChange = (value) => {
        setPageable((prevSearchObject) => ({
            ...prevSearchObject,
            size: value,
            page: 0
        }));
        setCallFlag(true);
    };

    useEffect(() => {
        Listener();
        setCallFlag(false)
    }, [callFlag]);


    return (
        <Select
            onValueChange={handleValueChange}
        >
            <SelectTrigger className="ml-2 mr-2">
                <SelectValue placeholder="10" />
            </SelectTrigger>
            <SelectContent >
                <SelectItem className="text-[0.7rem]" key={1} value={10}>{10}</SelectItem>
                <SelectItem className="text-[0.7rem]" key={2} value={20}>{20}</SelectItem>
                <SelectItem className="text-[0.7rem]" key={3} value={50}>{50}</SelectItem>
                <SelectItem className="text-[0.7rem]" key={4} value={100}>{100}</SelectItem>
                <SelectItem className="text-[0.7rem]" key={5} value={1000}>{1000}</SelectItem>
            </SelectContent>
        </Select>
    );
}

export default TableSizeSelect;